export default "__VITE_ASSET__C7eMtGH3__"